import { Component, OnInit } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {Actions, ofActionDispatched, Select, Store} from '@ngxs/store';
import {PaymentKeyState} from 'src/app/components/shared/map.state';
import { Session } from 'src/app/interfaces/session-data';
import { SessionService } from 'src/app/services/session/session.service';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import {catchError, filter} from 'rxjs/operators';

@Component({
  selector: 'app-ott-voucher-version-two',
  templateUrl: './ott-voucher.component.html',
  styleUrls: ['./ott-voucher.component.scss']
})
export class OttVoucherComponent implements OnInit {
  // ngxs-store
  @Select(PaymentKeyState) paymentkey$: Observable<object>;
  
  // session
  session: Session;

  // payment
  paymentMethod: string;

  loading: boolean = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private actions$: Actions,
    private sessionService: SessionService
  ) { 
    this.paymentMethod = 'ott_voucher';
    sessionStorage.setItem('selected-payment', 'ott_voucher');

    this.session = JSON.parse(sessionStorage.getItem('sessionData'));

    router.events
    .pipe(
      filter(
        (events) => {
          return (events instanceof NavigationStart);
        }
      )
    )
    .subscribe((events: NavigationStart) => {
      if (events.navigationTrigger === 'popstate') {
        this.loading = false;
      }
    });
  }

  ngOnInit(): void {
    sessionStorage.setItem('TRANSACTION_CONFIRMED_PAYMENT_METHOD', this.paymentMethod);
    if (this.router.routerState.snapshot.url.indexOf(`${this.paymentMethod}/`) === -1) {
      this.router.navigate(['input'], { relativeTo: this.route });
    } else {
      this.loading = false;
    }
    this.paymentkey$.pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  goBack() {
    this.router.navigate([`${this.sessionService.getVirtualTwoBaseurl()}`]);
    sessionStorage.setItem("goBack", "true");
  }

}
